import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ValueStackSection() {
  return <section className="py-6 px-4 bg-gray-900 text-white" data-id="element-280">
      <div className="max-w-3xl mx-auto bg-gray-800 rounded-3xl p-5 md:p-8 border-4 border-yellow-400 shadow-2xl" data-id="element-281">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E] uppercase" data-id="element-282">
          Todo lo que vas a recibir hoy
        </h2>

        <div className="mb-4" data-id="element-283">
          <h3 className="text-2xl font-bold mb-3" data-id="element-284">📦 Acceso inmediato a:</h3>
          <ul className="space-y-2 text-xl pl-4" data-id="element-285">
            <li className="flex items-center font-bold" data-id="element-286">
              <span className="text-yellow-400 mr-3" data-id="element-287">•</span> Ebook principal
              Efemérides Listas
            </li>
            <li className="flex items-center" data-id="element-288">
              <span className="text-yellow-400 mr-3" data-id="element-289">•</span> BONUS 1: Glosas
              Listas
            </li>
            <li className="flex items-center" data-id="element-290">
              <span className="text-yellow-400 mr-3" data-id="element-291">•</span> BONUS 2: Actos
              Resueltos
            </li>
            <li className="flex items-center" data-id="element-292">
              <span className="text-yellow-400 mr-3" data-id="element-293">•</span> BONUS 3: Pack
              Mundial
            </li>
          </ul>
        </div>

        <div className="border-t border-gray-600 pt-4" data-id="element-294">
          <h3 className="text-2xl font-bold mb-3" data-id="element-295">Además vas a tener:</h3>
          <ul className="space-y-2 text-lg" data-id="element-296">
            <li className="flex items-start" data-id="element-297">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-298" />
              <span data-id="element-299">explicaciones claras de cada efeméride</span>
            </li>
            <li className="flex items-start" data-id="element-300">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-301" />
              <span data-id="element-302">actividades listas para trabajar</span>
            </li>
            <li className="flex items-start" data-id="element-303">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-304" />
              <span data-id="element-305">material organizado para todo el año</span>
            </li>
            <li className="flex items-start" data-id="element-306">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-307" />
              <span data-id="element-308">recursos para actos escolares</span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}